import * as React from "react";

const NoData: React.FC = () => {
  return (
    <>
      <div className="text-center">
        <img
          src={process.env.STATIC_PATH + "/images/nodata.png"}
          className="object-cover inline-block select-none w-14 h-14"
        />
        <div className="text-sm mt-4 text-gray-400 pointer-events-none select-none">
          No Data Found!
        </div>
      </div>
    </>
  );
};

export default NoData;
